<app-header></app-header>
<app-page-title></app-page-title>

<div class="page-container">

  <!-- Page content -->
  <div class="page-content">

    <!-- Main content -->
    <div class="content-wrapper">

      <app-industry-card-view></app-industry-card-view>

      <div class="row">

        <div *ngIf="userLevel != 'vendor'" class="col-lg-6 col-md-6 col-sm-12">
          <app-industry-area-chart></app-industry-area-chart>
        </div>

        <div [ngClass]="userLevel != 'vendor' ? 'col-lg-6 col-md-6 col-sm-12' : 'col-lg-4 col-md-4 col-sm-12'">
          <app-industry-line-chart></app-industry-line-chart>
        </div>

        <div *ngIf="userLevel != 'vendor'" class="col-12">
          <app-all-industry-map></app-all-industry-map>
        </div>

        <div class="col-lg-4 col-md-4 col-sm-12">
          <app-least-performing-industry></app-least-performing-industry>
        </div>

        <div class="col-lg-4 col-md-4 col-sm-12">
          <app-most-closed-industry></app-most-closed-industry>
        </div>

        <div *ngIf="userLevel != 'vendor'" class="col-lg-4 col-md-4 col-sm-12">
          <app-venodr-with-max-closed-industry></app-venodr-with-max-closed-industry>
        </div>

        <div *ngIf="userLevel == 'vendor'" class="col-12">
          <app-all-industry-map></app-all-industry-map>
        </div>

        <div *ngIf="userLevel == 'admin' || userName == 'HSPCBCEMS' || production == false" class="col-12">
          <app-export-industry></app-export-industry>
        </div>

      </div>

    </div>
  </div>
</div>

<app-footer></app-footer>
